export default __webpack_public_path__ + "static/media/player-play.528844dc.svg";